module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step1a_Image16.0ae802f6.jpg";